module.exports = __webpack_public_path__ + "img/44.601d6361.jpg";